<template>

<div class="row">
    <div class="col-md-3">
        <div class="card card-primary card-outline">
            <div class="card-header">
                <h3 class="card-title">Transaction Detail</h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                        <i class="fas fa-minus"></i>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <form autocomplete="off">
                <div class="row">
                    <div class="col-md-12 form-group">
                        <label for="transaction_date">Transaction Date</label>
                        <input type="text" name="transaction_date" class="form-control input-sm datetimepicker-input" id="transaction_date" data-toggle="datetimepicker" data-target="#transaction_date" placeholder="Transaction Date" v-model="transaction.transaction_date" autocomplete="off">
                    </div>
                    <div class="col-md-12 form-group">
                        <label for="entity">{{trans('general.entity')}}</label>
                        <search-selecter :selectedValue="transaction.entity_name" :placeholder="trans('general.search')+' '+trans('general.entity')+' ...'" :ajaxUrl="searchEntity" id="entity_selecter" datatype="entityCurrent" ref="search_entity"
                            @selectitem="entitySelected"></search-selecter>
                    </div>
                    <div class="col-md-12 form-group">
                        <label for="cheque_date">Bank In Date</label>
                        <input type="text" name="cheque_date" class="form-control input-sm datetimepicker-input" id="cheque_date" data-toggle="datetimepicker" data-target="#cheque_date" placeholder="Cheque Date" v-model="transaction.cheque_date" autocomplete="off">
                    </div>
                    <div class="col-md-12 form-group">
                        <label for="cheque_number">Cheque Number (留空自動NA)</label>
                        <input type="text" class="form-control" name="cheque_number" id="cheque_number" placeholder="Cheque Number" v-model="transaction.cheque_number">
                    </div>
                    <div class="col-md-12 form-group">
                        <label for="bank_id">Cheque Bank</label>
                        <select class="form-control" name="bank_id" id="bank_id" v-model="transaction.bank_id">
                            <option value="0">- Cheque Bank -</option>
                            <option v-for="bank in banks" :key="bank.id" :value="bank.id">
                                {{bank.slug}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-12 form-group" v-if="transaction_type.id==2">
                        <label for="receive_bank_id">Reveice Bank</label>
                        <select class="form-control" name="receive_bank_id" id="receive_bank_id" v-model="transaction.receive_bank_id">
                            <option value="0">- Reveice Bank -</option>
                            <option v-for="bank in receive_banks" :key="bank.acc_account_id" :value="bank.acc_account_id">
                                {{bank.name_en}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-12 form-group">
                        <label for="transaction_total_amount">Total Amount</label>
                        <input type="text" class="form-control" name="transaction_total_amount" id="transaction_total_amount" placeholder="Total Amount" v-model="transaction.transaction_total_amount">
                    </div>
                    <div class="col-md-12 form-group">
                        <label for="diff">Difference</label>
                        <input type="text" class="form-control" name="diff" id="diff" placeholder="Difference" v-model="transaction.diff">
                    </div>
                    <div class="col-md-12 form-group">
                        <input type="button" name="addTrans" class="btn btn-block bg-gradient-primary" value="Add Transaction" @click="addTransaction" v-if="transaction.state==1">
                        <input type="button" name="subtrans" class="btn btn-block bg-gradient-success" value="Submit Transaction" @click="submitTranaction" v-if="transaction.state==2">
                    </div>
                    <div class="col-md-12 form-group">
                        <label for="start_date">Start Date</label>
                        <input type="text" name="start_date" class="form-control input-sm datetimepicker-input" id="start_date" data-toggle="datetimepicker" data-target="#start_date" placeholder="Start Date" v-model="transaction.start_date" autocomplete="off">
                    </div>
                    <div class="col-md-12 form-group">
                        <label for="end_date">End Date</label>
                        <input type="text" name="end_date" class="form-control input-sm datetimepicker-input" id="end_date" data-toggle="datetimepicker" data-target="#end_date" placeholder="End Date" v-model="transaction.end_date" autocomplete="off">
                    </div>
                    <div class="col-md-12 form-group" v-show="this.transaction.entity_id">
                        <input type="button" name="printStatement" class="btn btn-block bg-gradient-warning" value="Print Statement" @click="printStatement">
                    </div>
                    <template v-if="transaction_type.id==2">
                    <div class="col-md-12 form-group">
                        <label for="email">Entity Email</label>
                        <input type="text" class="form-control" name="email" id="email" placeholder="Entity Email" v-model="transaction.email">
                    </div>
                    <div class="col-md-12 form-group">
                        <input type="text" class="form-control" name="email2" id="email2" placeholder="Entity Email 2"  v-model="transaction.email2">
                    </div>
                    <div class="col-md-12 form-group" v-show="this.transaction.entity_id">
                        <input type="button" name="sendStatement" class="btn btn-block bg-gradient-primary" value="Send Statement" @click="sendStatement">
                    </div>
                    </template>
                </div>
                </form>
            </div>
        </div>

        <div class="card card-primary card-outline">
            <div class="card-header">
                <h3 class="card-title">Entities Current</h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                        <i class="fas fa-minus"></i>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12 form-group">
                        <label for="entity_filter">Search Entity</label>
                        <input type="text" class="form-control" name="entity_filter" id="entity_filter" placeholder="Search Entity" v-model="entityFilter">
                    </div>
                </div>
                <div class="row" style="max-height:500px;overflow: scroll;">
                    <div class="col-md-12">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Entity</th>
                                    <th>Current</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="entity in filteredEntity" :key="entity.id">
                                    <tr v-on:click="entitySelected(entity)" style="cursor:pointer">
                                        <td>{{entity.entity_number}}</td>
                                        <td>{{entity.entity_name}}</td>
                                        <td>{{entity.current}}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="col-md-9">
        <div class="card card-primary card-outline">
            <div class="card-header">
                <h3 class="card-title">Unpaid Order</h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                        <i class="fas fa-minus"></i>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Inv. Date</th>
                                    <th>Inv. #</th>
                                    <th class="text-right">Inv. Amount</th>
                                    <th class="text-right">Paid</th>
                                    <th class="text-right">Balance</th>
                                    <th>Payment</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(order, index) in unpaidOrders" :key="index">
                                    <tr>
                                        <td>{{order.order_date}}</td>
                                        <td>{{order.order_number}}</td>
                                        <td class="text-right">{{order.order_total_amount.toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}}</td>
                                        <td class="text-right">{{order.order_payment_amount.toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}}</td>
                                        <td class="text-right">{{order.balance.toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}}</td>
                                        <td>
                                            <input type="text" name="transaction_amount" v-if="transaction.state==2" v-model="order.transaction_amount" v-on:dblclick="setFullPay(order,index)" v-on:change="updateTrasactionDiff"/>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

</template>

<script>
import Big from 'big.js';
import {enUS, zhHK,zhCN} from 'date-fns/locale'

export default {
    name: 'transaction-panel',
    props:['transaction_type','entities','banks','receive_banks','lang'],
    components:{},
    mounted() {
        console.log('[NB] transaction-panel mounted. Props:', {
            transaction_type: this.transaction_type,
            entitiesCount: Array.isArray(this.entities)? this.entities.length : typeof this.entities,
            banksCount: Array.isArray(this.banks)? this.banks.length : typeof this.banks,
            lang: this.lang,
        });
        if (this.lang==1) this.locale = zhHK;
        else if (this.lang==2) this.locale = zhCN;

        // Initialize Bootstrap datetimepickers like order-detail
        const self = this;
        try{
            ['#transaction_date','#cheque_date','#start_date','#end_date'].forEach(function(sel){
                if (window.$ && $(sel).length) {
                    $(sel).datetimepicker({ format: 'YYYY-MM-DD' });
                    // set initial value if empty
                    var val = $(sel).val();
                    if(!val){
                        var d = new Date();
                        var m = (d.getMonth() + 1).toString().padStart(2, '0');
                        var day = d.getDate().toString().padStart(2, '0');
                        var init = d.getFullYear() + '-' + m + '-' + day;
                        $(sel).val(init);
                        if(sel=='#transaction_date') self.transaction.transaction_date = init;
                        if(sel=='#cheque_date') self.transaction.cheque_date = init;
                        if(sel=='#start_date') self.transaction.start_date = init;
                        if(sel=='#end_date') self.transaction.end_date = init;
                    }
                    $(sel).on('change.datetimepicker change', function(){
                        var v = $(sel).val();
                        if(sel=='#transaction_date') self.transaction.transaction_date = v;
                        if(sel=='#cheque_date') self.transaction.cheque_date = v;
                        if(sel=='#start_date') self.transaction.start_date = v;
                        if(sel=='#end_date') self.transaction.end_date = v;
                    });
                }
            });
        }catch(e){ console.warn('[NB] datepicker init failed', e); }
    },
    data: function() {
        return {
            transaction:{
                transaction_date: null,
                cheque_date: null,
                cheque_number:'',
                transaction_total_amount:'',
                remark:'',
                entity_name:'',
                entity_id:'',
                bank_id:0,
                receive_bank_id:1,
                diff:'',
                state:1,
                email:'',
                email2:'',
                start_date: null,
                end_date: null,
            },
            unpaidOrders:[],
            entityFilter:'',
            locale:enUS,

        }
    },
    computed: {
        searchEntity: function() {
            return '/admin/searchEntityCurrent/' + this.transaction_type.id;
        },
        filteredEntity: function (){
            return this.entities.filter(function (entity){
                if(entity.name_en&&entity.name_en.toUpperCase().includes(this.toUpperCase())){
                    return true;
                }else if(entity.name_zh&&entity.name_zh.toUpperCase().includes(this.toUpperCase())){
                    return true;
                }else if(entity.entity_number.includes(this)){
                    return true;
                }else if(this == ''){
                    return true;
                }else{
                    return false;
                }
           }, this.entityFilter)
        }
    },
    methods: {
        trans:function(key){
            try{
                return key;
            }catch(e){
                return key;
            }
        },
        printStatement:function(){
            var date_filter='';
            if(this.transaction.start_date!=null){
                var date = this.transaction.start_date;
                var date = new Date(date.setTime(date.getTime() + 8*60*60*1000));
                date_filter = date_filter+'&start_date='+ date.toISOString().split('T')[0];
            }
            if(this.transaction.end_date!=null){
                var date = this.transaction.end_date;
                var date = new Date(date.setTime(date.getTime() + 8*60*60*1000));
                date_filter = date_filter+'&end_date='+date.toISOString().split('T')[0];
            }
            window.open('/printStatement?entity_id='+this.transaction.entity_id+date_filter);
        },

        sendStatement:function(){
            var data ={
                entity_id : this.transaction.entity_id,
                email : this.transaction.email,
                email2 : this.transaction.email2,
                tofile :1,
            }
            var self = this;
            this.$store.commit('startAjaxLoading');
            axios.post('/sendStatement', data)
            .then(function(response) {
                self.$store.commit('stopAjaxLoading');

                if (response.data.result == 'success') {
                    window.location.href = response.data.redirect;
                } else if (response.data.result == 'failed') {
                    alert(response.data.message);
                }
            })
            .catch(function(error) {
                self.$store.commit('stopAjaxLoading');
                alert(response.data.message);
            });
        },

        entitySelected: function(item) {
            this.transaction.entity_name = item.entity_name;
            this.transaction.entity_id = item.id;
            this.transaction.email = item.email;
            this.getUpaidOrders(item.id);
        },

        getUpaidOrders :function(entity_id){
            //alert('yo');
            var data = {
                entity_id:entity_id,
            }
            var self= this;
            if (this.$store.ajaxLoading) {
                return false;
            }
            if(this.transaction.state==2){
                alert('Please finish the transaction.');
                return false;
            }
            this.$store.commit('startAjaxLoading');
            axios.post('/admin/ajaxEntityUnpaidOrders', data )
                .then(function(response) {

                    if (response.data.result == 'success') {
                        self.unpaidOrders = response.data.data;

                    } else {
                        alert(response.data.message);
                    }

                    self.$store.commit('stopAjaxLoading');
                })
                .catch(function(error) {
                    alert(error);
                    self.$store.commit('stopAjaxLoading');
                });
        },

        addTransaction:function(){
            var validate = true;
            var message = [];
            if(this.transaction.transaction_date==''){
                validate = false;
            }
            if(this.transaction.entity_id==''){
                validate = false;
            }
            if(this.transaction.cheque_date==''){
                // validate = false;
                this.transaction.cheque_date = null;
            }
            if(this.transaction.cheque_number==''){
                // validate = false;
                this.transaction.cheque_number = 'NA';
            }
            if(this.transaction.bank_id==''){
                // validate = false;
                this.transaction.bank_id = 0;
            }
            if(this.transaction.transaction_total_amount==''){
                validate = false;
            }
            if(validate){
                this.startEditTransaction();
            }else{
                alert('Please input all transaction data.');
            }
        },

        setFullPay:function(order,index){
            var updateOrder = this.unpaidOrders[index];
            updateOrder.transaction_amount = order.balance;
            // Vue.set(this.unpaidOrders, index, updateOrder);
            this.unpaidOrders.index = updateOrder;
            this.updateTrasactionDiff();
        },

        startEditTransaction:function(){
            this.transaction.state=2;
        },

        submitTranaction:function(){
            var total_transaction_amount = 0;
            for(var i=0 ; i<this.unpaidOrders.length;i++){
                if(this.unpaidOrders[i].transaction_amount>0){
                    total_transaction_amount =  Big(total_transaction_amount).plus(Big(this.unpaidOrders[i].transaction_amount));
                }
            }
            if(total_transaction_amount == this.transaction.transaction_total_amount){
                alert('good');
                this.submitTransaction();
            } else {
                alert('Transaction total amount not matched.');
            }
        },

        updateTrasactionDiff(){
            var total_transaction_amount=0
            for(var i=0 ; i<this.unpaidOrders.length;i++){
                if(this.unpaidOrders[i].transaction_amount>0){
                    total_transaction_amount =  Big(total_transaction_amount).plus(Big(this.unpaidOrders[i].transaction_amount));
                }
            }
            this.transaction.diff = Big(this.transaction.transaction_total_amount).minus( Big(total_transaction_amount));
        },

        submitTransaction(){
            this.transaction.transaction_type_id = this.transaction_type.id;
            var items = [];
            for(var i=0 ; i<this.unpaidOrders.length;i++){

                if(this.unpaidOrders[i].transaction_amount>0){
                    items.push(this.unpaidOrders[i]);
                }

            }
            var self = this;
            var data = {
                transaction : self.transaction,
                transaction_items : items,
            }
            
            this.$store.commit('startAjaxLoading');
            axios.post('/admin/addTransaction', data)
            .then(function(response) {
                self.$store.commit('stopAjaxLoading');

                if (response.data.result == 'success') {
                    window.location.href = response.data.redirect;
                } else if (response.data.result == 'failed') {
                    alert(response.data.message);
                }
            })
            .catch(function(error) {
                self.$store.commit('stopAjaxLoading');
                alert(response.data.message);
            });
        }
    }
}
</script>
